export const AGILE_ORG = 'theagileexecutive';
export const AGILE_ORG_NAME = 'The Agile Executive'; // Similarly we can create for other Organozations also
/** Internal Dosen team org — used to bypass user-facing checks (mandatory fields, etc.). */
export const DOSEN_TEAM_ORG_NAME = 'Dosen';
/** Auth0 org IDs where the Missing Mandatory Fields modal should never appear. */
export const MANDATORY_FIELDS_DISABLED_ORG_IDS = ['org_6ITcHu9aTmvhI9Qx'];
// Orgs that get course versioning (Designer draft, Version History, Publish
// update, learner What's new) without the BE `courseVersioning` org flag.
// Empty by default: organization.flags.courseVersioning is the switch.
export const COURSE_VERSIONING_PILOT_ORG_IDS: string[] = [];
// Orgs that get the Capability release (Capability Setup, the Capability and
// Activity tabs, the Activity tier names) without the BE `capabilityRelease`
// org flag. A pilot: The Playground only. See utils/capabilityRelease.ts.
export const CAPABILITY_RELEASE_PILOT_ORG_IDS: string[] = ['org_GiHz1oRmIxSq03YX'];
// Orgs force-frozen on the FE regardless of the BE `editingFrozen` org flag.
// Empty by default: the flag (organization.flags.editingFrozen) is the switch.
export const EDITING_FROZEN_ORG_IDS: string[] = [];
export const EDITING_FROZEN_MESSAGE =
  'Editing is paused while we update your programs for relaunch. Contact Cian if you need a change.';
export const AGILE_ALLOWED_CATEGORY_COMMUNITY = ['Agile Consultant', 'Consultant'];
export const AGILE_MENTOR_ROLE_TAG = 'Agile Consultant';
export const LABEL_MAPPINGS = [
  { original: 'Client', formatted: 'I’m looking for a consultant' },
  { original: 'Consultant', formatted: 'I am a consultant' }
  // Add more label mappings as needed
];
export const STAR_VENTURE = 'starventure';
export const STAR_VENTURE_NAME = 'star venture';
export const RDP_CREATIVE = 'rdpcreative';
export const RDP_CREATIVE_ORG_ID = '662a76553f68208121a07fcb';
export const ORFIUM = 'orfium';
// export const ORFIUM_GROUP_ID = '66f5320a841f4ff87de6a651';
// export const ORFIUM_GROUP_ID = '66fa90dff25799ad4a4bc06e';
export const ORFIUM_GROUP_ID = '66c3d0bfb014a947b2a74ca9';
export const ORG_TYPES = {
  govt: 'Government & Development Organisation',
  corporate: 'Corporate',
  highEd: 'Higher Education'
};
export const levelTypes = {
  activeNow: 'activeNow',
  daysAfterSignup: 'daysAfterSignup',
  calendarDate: 'calendarDate',
  availableSoon: 'availableSoon'
};
